import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { Table } from "@/features/Table";

import { type FilterFoBankContactSchema, FilterFoBankContact } from "./filter";
import { type FoBankContact, getFoBankContactColumns } from "./columns";

const client = "fo-quantilia";
const table_name = "fo_bank_contact";

export const FoBankContactTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;
  const { t } = useTranslation();
  const columns = getFoBankContactColumns(t);

  return (
    <Table<FoBankContact, FilterFoBankContactSchema>
      label={t("fo_bank_contact.title")}
      client={client}
      table_name={table_name}
      columns={columns}
      filter={<FilterFoBankContact />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
